export const BENEFITS_PERKS_TABS = [
  "legal-and-financial-support",
  "mind-and-body-support",
  "save-money-on-medical-bills"
] as const;

export type BenefitsPerksTab = (typeof BENEFITS_PERKS_TABS)[number];
